import { render, staticRenderFns } from "./RecoveryCode.vue?vue&type=template&id=16d4074b&"
import script from "./RecoveryCode.vue?vue&type=script&lang=js&"
export * from "./RecoveryCode.vue?vue&type=script&lang=js&"
import style0 from "./RecoveryCode.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports